<main
    *ngIf="mediaSubscription"
    class="agpr-mediaSubscription"
>
    <div class="agpr-mediaSubscription-primaryGrid">
        <section
            class="agpr-mediaSubscription-centerPanel"
            [attr.aria-label]="'Common.layout.main' | localize"
        >
            <agpr-scroll-panel #scrollArea>
                <div class="agpr-mediaSubscription-content">
                    <header>
                        @if (mediaSubscription.name) {
                            <h2 class="agpr-mediaSubscription-name">{{ mediaSubscription.name | localize }}</h2>
                        }
                        <h2 class="u-srOnly">
                            {{ 'MediaSubscriptions.mediaSubscriptionSetupHeading' | localize }}
                        </h2>
                    </header>
                    <agpr-message
                        class="agpr-mediaSubscription-primaryInfo"
                        [severity]="messageSeverityEnum.info"
                    >
                        {{ 'MediaSubscriptions.mediaSubscription.primaryInfo' | localize }}
                        <br>
                        @if (mediaSubscription.type !== mediaTypesEnum.broadcast && mediaSubscription.type !== mediaTypesEnum.podcast) {
                            {{ 'MediaSubscriptions.mediaSubscription.primaryDisclaimer.quota' | localize }}
                        }

                        @if (mediaSubscription.type === mediaTypesEnum.broadcast) {
                            {{ 'MediaSubscriptions.mediaSubscription.primaryDisclaimer.noquota' | localize }}
                        }

                        @if (mediaSubscription.type === mediaTypesEnum.podcast) {
                            {{ 'MediaSubscriptions.mediaSubscription.primaryDisclaimer.noquotaForPodcast' | localize }}
                        }
                    </agpr-message>

                    @if (mediaSubscription.status === mediaSubscriptionStatusEnum.STAND_BY) {
                        <agpr-message
                            class="agpr-mediaSubscription-primaryInfo"
                            [severity]="messageSeverityEnum.warning"
                        >
                            {{ 'MediaSubscriptions.mediaSubscription.standByWarning.lineOne' | localize }}
                            <br>
                            {{ 'MediaSubscriptions.mediaSubscription.standByWarning.lineTwo.beforeLink' | localize }}
                            <a
                                routerLink="/Monitoring/subscriptions/dashboard"
                                class="agpr-mediaSubscription-primaryInfoLink"
                            >{{ 'MediaSubscriptions.mediaSubscription.standByWarning.lineTwo.linkText' | localize }}</a>
                            {{ 'MediaSubscriptions.mediaSubscription.standByWarning.lineTwo.afterLink' | localize }}
                        </agpr-message>
                    }

                    <div class="agpr-mediaSubscription-contentForm">
                        <fieldset class="agpr-mediaSubscription-mediaTypesContainer">
                            <legend class="agpr-mediaSubscription-legend">
                                {{ 'MediaSubscriptions.SubscribeTo' | localize }}
                            </legend>
                            <div
                                class="agpr-mediaSubscription-radioGroup"
                                role="radiogroup"
                                [attr.aria-label]="'MediaSubscriptions.mediaTypeOptions' | localize"
                            >
                                <ng-container *ngFor="let mediaType of mediaTypes; index as i">
                                    <!--
                                        hide if the type is meant to be hidden and is not the currently selected type
                                        this allows old subscriptions to still show their type, even if it would normally be hidden
                                        it will still be disabled even if it is visible for this reason
                                    -->
                                    @if (!mediaType.hidden || mediaSubscription.type === mediaType.id) {
                                        <label class="agpr-mediaSubscription-mediaTypeSelector">
                                            @if (mediaTypes.length > 1) {
                                                <agpr-radio
                                                    [id]="'mediaSubscription.mediaTypes_' + i"
                                                    name="mediaType"
                                                    [value]="mediaType.id"
                                                    [(ngModel)]="mediaSubscription.type"
                                                    (ngModelChange)="updateHandlesLabel(); checkForUpdates(); setFormMode(); onSubscriptionChange();"
                                                    [disabled]="mediaType.disabled"
                                                ></agpr-radio>
                                            }
                                            <div
                                                class="agpr-mediaSubscription-mediaTypeLabel"
                                                [ngClass]="{'agpr-mediaSubscription-mediaTypeLabel--disabled': mediaType.disabled}"
                                            >
                                                <i [class]="mediaType.icon + ' agpr-mediaSubscription-mediaTypeIcon'"></i>
                                                <span class="agpr-mediaSubscription-mediaTypeLabel">{{ mediaType.name | localize }}</span>
                                            </div>

                                            @if (mediaType.disabled) {
                                                <span
                                                    role="img"
                                                    class="agpr-mediaSubscription-lockIcon fa-regular fa-lock fa-duotone"
                                                    [agprTooltip]="'MediaTypeCheckbox.notProvisionedIconToolTip' | localize: {mediaType: mediaType.name}"
                                                ></span>
                                            }
                                        </label>
                                    }

                                </ng-container>
                            </div>
                        </fieldset>
                        <div
                            role="radiogroup"
                            tabindex="-1"
                            [attr.aria-label]="'MediaSubscriptions.formLabel' | localize"
                            [attr.aria-invalid]="showErrors"
                            [attr.aria-describedby]="formMode === formModeEnum.KEYWORDS ? 'mediaSubscription_keywordErrors' : 'mediaSubscription_handleErrors'"
                            class="agpr-mediaSubscription-form"
                        >
                            <agpr-radio
                                [id]="id + '_keywordsRadioButton'"
                                [(ngModel)]="formMode"
                                (ngModelChange)="checkForUpdates()"
                                [value]="formModeEnum.KEYWORDS"
                                name="form_mode"
                                label="MediaSubscriptions.labels.keywords"
                                hiddenLabel="MediaSubscriptions.labels.keywords"
                                labelStyleClass="agpr-mediaSubscription-radioButtonLabel"
                                class="agpr-mediaSubscription-keywordsRadioButton"
                                [disabled]="mediaSubscription.type === mediaTypesEnum.broadcast || mediaSubscription.type === mediaTypesEnum.podcast"
                            ></agpr-radio>
                            <div class="agpr-mediaSubscription-keywordInputContainer">
                                <agpr-monitoring-keywords-input
                                    [id]="id + '_keywordGroup_and'"
                                    styleClass="agpr-mediaSubscription-keywordInput"
                                    [label]="andWordsDescription"
                                    [labelType]="inputTypesEnum.template"
                                    [keywordValidations]="mediaSubscription.keywords.keywordValidations"
                                    [value]="mediaSubscription.keywords.and"
                                    (valueChange)="setKeywords('and', $event);"
                                    [disabled]="formMode !== formModeEnum.KEYWORDS"
                                ></agpr-monitoring-keywords-input>

                                <agpr-monitoring-keywords-input
                                    [id]="id + '_keywordGroup_or'"
                                    styleClass="agpr-mediaSubscription-keywordInput"
                                    [label]="orWordsDescription"
                                    [labelType]="inputTypesEnum.template"
                                    [keywordValidations]="mediaSubscription.keywords.keywordValidations"
                                    [value]="mediaSubscription.keywords.or"
                                    (valueChange)="setKeywords('or', $event);"
                                    [disabled]="formMode !== formModeEnum.KEYWORDS"
                                ></agpr-monitoring-keywords-input>

                                <agpr-monitoring-keywords-input
                                    [id]="id + '_keywordGroup_not'"
                                    styleClass="agpr-mediaSubscription-keywordInput--last"
                                    [label]="notWordsDescription"
                                    [labelType]="inputTypesEnum.template"
                                    [keywordValidations]="mediaSubscription.keywords.keywordValidations"
                                    [value]="mediaSubscription.keywords.not"
                                    (valueChange)="setKeywords('not', $event);"
                                    [disabled]="formMode !== formModeEnum.KEYWORDS"
                                ></agpr-monitoring-keywords-input>
                                <ul [id]="id + '_keywordErrors'">
                                    @if (showErrors) {
                                        @if (errors.noIncludeKeywords) {
                                            <li>
                                                <agpr-form-message>
                                                    {{ 'MediaSubscriptions.errors.keywordsRequired' | localize }}
                                                </agpr-form-message>
                                            </li>
                                        }
                                        @if (errors.hashtagHasPunctuation) {
                                            <li>
                                                <agpr-form-message>
                                                    {{ 'MediaSubscriptions.errors.keywordHashtagHasPunctuation' | localize }}
                                                </agpr-form-message>
                                            </li>
                                        }
                                        @if (errors.tooManyTerms && formMode === formModeEnum.KEYWORDS) {
                                            <li>
                                                <agpr-form-message>
                                                    {{ 'MediaSubscriptions.errors.tooManyKeywords' | localize }}
                                                </agpr-form-message>
                                            </li>
                                        }
                                        @if (errors.duplicateKeywords) {
                                            <li>
                                                <agpr-form-message>
                                                    {{ 'MediaSubscriptions.errors.duplicateKeywords' | localize }}
                                                </agpr-form-message>
                                            </li>
                                        }
                                    }
                                </ul>
                            </div>

                            @if (mediaSubscription.type !== mediaTypesEnum.broadcast && mediaSubscription.type !== mediaTypesEnum.podcast) {
                                <div class="agpr-mediaSubscription-divider"></div>
                                <agpr-radio
                                    [id]="id + '_handlesRadioButton'"
                                    [(ngModel)]="formMode"
                                    (ngModelChange)="checkForUpdates()"
                                    [value]="formModeEnum.HANDLES"
                                    name="form_mode"
                                    [label]="handlesName"
                                    [hiddenLabel]="handlesName"
                                    labelStyleClass="agpr-mediaSubscription-radioButtonLabel"
                                ></agpr-radio>

                                <div class="agpr-mediaSubscription-keywordInputContainer">
                                    <agpr-monitoring-keywords-input
                                        [id]="id + '_keywordGroup_handleOr'"
                                        styleClass="agpr-mediaSubscription-keywordInput"
                                        [label]="handlesDescription"
                                        [labelType]="inputTypesEnum.template"
                                        [keywordValidations]="handleValidators"
                                        [value]="mediaSubscription.keywords.handles"
                                        (valueChange)="setKeywords('handles', $event);"
                                        [placeholder]="handlesPlaceholder | localize"
                                        [disabled]="formMode !== formModeEnum.HANDLES"
                                    ></agpr-monitoring-keywords-input>
                                    <ul [id]="id + '_handleErrors'">
                                        @if (showErrors) {
                                            @if (errors.noHandles) {
                                                <li>
                                                    <agpr-form-message>
                                                        {{ 'MediaSubscriptions.errors.handlesRequired' | localize }}
                                                    </agpr-form-message>
                                                </li>
                                            }
                                            @if (errors.tooManyTerms && formMode === formModeEnum.HANDLES) {
                                                <li>
                                                    <agpr-form-message>
                                                        {{ 'MediaSubscriptions.errors.tooManyHandles' | localize }}
                                                    </agpr-form-message>
                                                </li>
                                            }
                                        }
                                    </ul>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </agpr-scroll-panel>

            @if (mediaSubscriptionsProvisioned && mediaSubscription) {
                <agpr-action-bar>
                    <ng-template #right>
                        @if (!mediaSubscription.id) {
                            <agpr-button
                                [id]="id + '_save'"
                                label="save"
                                [disabled]="saveButtonState()"
                                [style]="buttonTypes.primary"
                                (click)="save()"
                            ></agpr-button>
                        } @else {
                            @if (!isDirty) {
                                <agpr-button
                                    [id]="id + '_viewMentions'"
                                    label="Monitoring.mediaSubscriptions.viewMentions"
                                    [style]="buttonTypes.primaryB"
                                    (click)="viewMentions()"
                                ></agpr-button>
                            }

                            <agpr-button
                                [id]="id + '_saveAsNew'"
                                label="MediaSubscriptions.buttons.saveAsNew"
                                [style]="buttonTypes.primaryB"
                                (click)="save()"
                            ></agpr-button>

                            @if (isDirty) {
                                <agpr-button
                                    [id]="id + '_saveChanges'"
                                    label="saveChanges"
                                    [style]="buttonTypes.primaryB"
                                    (click)="update()"
                                ></agpr-button>
                            }

                            @if (mediaSubscription.status === mediaSubscriptionStatusEnum.PAUSED) {
                                <agpr-button
                                    [id]="id + '_activate'"
                                    label="activate"
                                    [style]="buttonTypes.primary"
                                    (click)="activate()"
                                    [tooltip]="activateButtonTooltip | localize"
                                    [disabled]="disableActivateButton"
                                ></agpr-button>
                            } @else {
                                <agpr-button
                                    [id]="id + '_pause'"
                                    label="pause"
                                    [style]="buttonTypes.primary"
                                    (click)="pause()"
                                ></agpr-button>
                            }
                        }
                    </ng-template>
                </agpr-action-bar>
            }
        </section>

        <aside
            class="agpr-mediaSubscription-sidebar"
            [attr.aria-label]="'Common.layout.rhp' | localize"
        >
            <agpr-right-sidebar>
                <agpr-tab
                    [id]="'mediaSubscriptionDetails'"
                    icon=" fa-list-ul"
                    tooltip="MediaSubscriptions.rhp.details"
                >
                    @if (mediaSubscription.id) {
                        <agpr-panel header="Monitoring.mediaSubscriptions.subscriptionDetails">
                            <agpr-attribute-list
                                [attributes]="attributes"
                            ></agpr-attribute-list>
                        </agpr-panel>
                    }

                    @if (mediaSubscription.type === mediaTypesEnum.broadcast) {
                        <agpr-panel header="Monitoring.mediaSubscriptions.subscriptionRefinements">
                            <span>{{ 'Monitoring.mediaSubscriptions.tveyes.mediaType.label' | localize }}</span>
                            <div
                                class="agpr-mediaSubscription-tveyesRadioContainer"
                                role="radiogroup"
                                [attr.aria-label]="'Monitoring.mediaSubscriptions.tveyes.mediaType.label' | localize"
                            >
                                <agpr-radio
                                    [id]="id + '_tveyesType_all'"
                                    label="Monitoring.mediaSubscriptions.tveyes.mediaType.all"
                                    hiddenLabel="Monitoring.mediaSubscriptions.tveyes.mediaType.all"
                                    [value]="tvEyesMediaTypes.all"
                                    name="tveyes_type"
                                    [(ngModel)]="mediaSubscription.tvEyesMediaType"
                                    (ngModelChange)="onSubscriptionChange()"
                                ></agpr-radio>
                                <agpr-radio
                                    [id]="id + '_tveyesType_tv'"
                                    label="Monitoring.mediaSubscriptions.tveyes.mediaType.tv"
                                    hiddenLabel="Monitoring.mediaSubscriptions.tveyes.mediaType.tv"
                                    [value]="tvEyesMediaTypes.tv"
                                    name="tveyes_type"
                                    [(ngModel)]="mediaSubscription.tvEyesMediaType"
                                    (ngModelChange)="onSubscriptionChange()"
                                ></agpr-radio>
                                <agpr-radio
                                    [id]="id + '_tveyesType_radio'"
                                    label="Monitoring.mediaSubscriptions.tveyes.mediaType.radio"
                                    hiddenLabel="Monitoring.mediaSubscriptions.tveyes.mediaType.radio"
                                    [value]="tvEyesMediaTypes.radio"
                                    name="tveyes_type"
                                    [(ngModel)]="mediaSubscription.tvEyesMediaType"
                                    (ngModelChange)="onSubscriptionChange()"
                                ></agpr-radio>
                            </div>
                        </agpr-panel>
                    }

                    <agpr-panel header="Monitoring.mediaSubscriptions.subscriptionQuery">
                        <div class="agpr-definitionList">
                            @if (formMode === formModeEnum.HANDLES && mediaSubscription.keywords.handles.length > 0) {
                                <div class="agpr-definitionList-definitionTitle">
                                    {{ handlesName | localize }}
                                </div>

                                <div class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription">
                                    <ng-container *ngFor="let handle of mediaSubscription.keywords.handles; let last = last;">
                                        <span class="agpr-keywordGroupSummary-keyword">
                                            {{ handle }}
                                        </span>
                                        <span *ngIf="!last" class="agpr-keywordGroupSummary-operator">
                                            {{ 'KeywordGroupSummary.or' | localize }}
                                        </span>
                                    </ng-container>
                                    &nbsp;
                                </div>
                            } @else if (formMode === formModeEnum.KEYWORDS && mediaSubscription.keywords?.hasAnyKeywords()) {
                                <div  class="agpr-definitionList-definitionTitle">
                                    {{ 'Monitoring.mediaSubscriptions.keywords' | localize }}
                                </div>

                                <div class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription">
                                    <agpr-keyword-group-summary
                                        [keywordGroup]="mediaSubscription.keywords"
                                        [styleClass]="null"
                                    ></agpr-keyword-group-summary>
                                </div>
                            }
                        </div>
                    </agpr-panel>
                </agpr-tab>

                @if (mediaSubscription.id) {
                    <agpr-tab
                        [id]="id + '_Charts'"
                        icon=" fa-chart-pie"
                        tooltip="MediaSubscriptions.rhp.charts"
                    >
                        <agpr-panel header="MediaSubscriptions.dashboard.quotaOverTime.heading">
                        <div>
                            <a
                                routerLink="/Monitoring/subscriptions/dashboard"
                                class="agpr-mediaSubscription-viewDashboardLink"
                            >{{ 'MediaSubscriptions.dashboard.viewSubscriptionDashboard.label' | localize }}</a>
                        </div>
                            <agpr-quota-usage-over-time-chart></agpr-quota-usage-over-time-chart>
                        </agpr-panel>
                    </agpr-tab>
                }


                @if (mediaSubscription.id && mediaSubscription.type === mediaTypesEnum.broadcast) {
                    <agpr-tab
                        [id]="id + '_Backfill'"
                        icon=" fa-clock-rotate-left"
                        tooltip="MediaSubscriptions.rhp.backfill"
                    >
                        <agpr-message [severity]="messageSeverityEnum.info">
                            {{ 'MediaSubscriptions.backfill.infoMessage' | localize }}
                        </agpr-message>

                        @if (mediaSubscription.backfills) {
                            <agpr-panel header="MediaSubscriptions.backfill.status">
                                <ng-container *ngFor="let atts of backfillAttributes; let last = last">
                                    <div class="agpr-mediaSubscription-backfillList">
                                        <agpr-attribute-list
                                            [attributes]="atts"
                                        ></agpr-attribute-list>
                                    </div>
                                    <div
                                        *ngIf="!last"
                                        class="agpr-mediaSubscription-separator"
                                    ></div>
                                </ng-container>
                            </agpr-panel>
                        }

                        <ng-template #tabFooter>
                            <agpr-action-bar>
                                <ng-template #left>
                                    <agpr-button
                                        label="MediaSubscriptions.backfill.newRequest"
                                        [style]="buttonTypes.tertiary"
                                        (click)="backfill()"
                                    ></agpr-button>
                                </ng-template>
                                <ng-template #right>
                                    <agpr-button
                                        label="MediaSubscriptions.backfill.refresh"
                                        [style]="buttonTypes.tertiary"
                                        (click)="refresh()"
                                    ></agpr-button>
                                </ng-template>
                            </agpr-action-bar>
                        </ng-template>
                    </agpr-tab>
                }

                @if (showFinancialTimesPodcastUpsell) {
                    <ng-template #footer>
                            <div class="agpr-mediaSubscriptionDetails-container">
                                <div class="agpr-mediaSubscriptionDetails-upsell">
                                    <div class="agpr-mediaSubscriptionDetails-upsell-heading">
                                        <span
                                            class="agpr-mediaSubscriptionDetails-upsell-icon fa-kit-duotone fa-agpr-data-connection"
                                            aria-hidden="true"
                                        ></span>
                                        {{ 'MediaSubscriptions.financialPodcasts.upsell.header' | localize}}
                                    </div>
                                    <div class="agpr-mediaSubscriptionDetails-upsell-content">
                                        <span>{{ 'MediaSubscriptions.financialPodcasts.upsell.text' | localize}}
                                            <agpr-button
                                                [id]="id + '_Details_podcastUpsell'"
                                                label="MediaSubscriptions.financialPodcasts.upsell.actionButton"
                                                [style]="buttonTypes.tertiary"
                                                (click)="upsellPodcasts()"
                                                ariaLabel="MediaSubscriptions.financialPodcasts.upsell.actionButton"
                                            ></agpr-button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                    </ng-template>
                }
            </agpr-right-sidebar>
        </aside>
    </div>
</main>

<!-- Input label localization templates-->
<ng-template #handlesDescription>
    {{ handlesLabel | localize }}
    -
    <span class="agpr-mediaSubscription-operator">
        {{ 'or' | localize }}
    </span>
</ng-template>

<ng-template #orWordsDescription>
    {{ 'MediaSubscriptions.orWordsDescription' | localize }}
    -
    <span class="agpr-mediaSubscription-operator">
        {{ 'or' | localize }}
    </span>
</ng-template>

<ng-template #andWordsDescription>
    {{ 'MediaSubscriptions.andWordsDescription' | localize }}
    -
    <span class="agpr-mediaSubscription-operator">
        {{ 'and' | localize }}
    </span>
</ng-template>

<ng-template #notWordsDescription>
    {{ 'MediaSubscriptions.notWordsDescription' | localize }}
    -
    <span class="agpr-mediaSubscription-operator">
        {{ 'not' | localize }}
    </span>
</ng-template>
